module.exports = __webpack_public_path__ + "media/images/eatokra-business-6e4d7c7a0b56e1b430debadce036a737.png";